import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Swal from 'sweetalert2'; import $ from "jquery";
import {
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

const SupplyChainLoading = () => {


  const topScrollSemiRef = useRef(null);
  const tableContainerSemiRef = useRef(null);





  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  let season_start = localStorage.getItem("season_start");
  let season_end = localStorage.getItem("season_end");


  const start = parseInt(season_start.slice(0, 4), 10);
  const end = parseInt(season_end.slice(0, 4), 10);

  const years = [];

  for (let y = start; y <= end; y++) {
    const inner_year = {  // Changed from [] to {}
      value: y,
      label: y,
      key: y
    };

    years.push(inner_year);
  }
  console.log(years); // [2025, 2026, 2027, 2028]

  console.log(season_start);
  console.log(season_end);
  useEffect(() => {
    setPermission(FindModuleById(111));
    console.log(permission);

    axios.post(
      "/supply-chain-loading/listing",
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        setData(response.data.data.supply_chain_loading);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/supply-chain-loading/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              // setTimeout(() => {
              //   window.location.href = "/supplychain-loadings";
              // }, 500);
              axios.post("/supply-chain-loading/listing", formData, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              }).then((response) => {
                setData(response.data.data.supply_chain_loading);
              }).catch((error) => {
                console.log(error);
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const statusOptions = [
    {
      "id": 1,
      "title": "Draft",
      "color": "white",
      "bg_color": "red",
    },
    {
      "id": 2,
      "title": "In Transit",
      "color": "white",
      "bg_color": "blue",
    },
    {
      "id": 3,
      "title": "Delivered",
      "color": "white",
      "bg_color": "green",
    },
  ];


  const editItem = (item) => {
    window.location.href = "/supplychain-loadings-edit/" + item;
  }



  const changeOrderStatus = (user_id, status, type) => {

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/supply-chain-loading/change-status/${user_id}/${status}`, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
          .then((response) => {
            console.log(response.data.data.paymentstatus);
            if (response.data.code === 200) {
              $("#status-" + type + "-" + user_id).text(response.data.data.paymentstatus.title);
              $("#status-" + type + "-" + user_id).css('background-color', response.data.data.paymentstatus.bg_color);
              $("#status-" + type + "-" + user_id).css('color', response.data.data.paymentstatus.color);


              axios.post("/supply-chain-loading/listing", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
                .then((response) => {
                  setData(response.data.data.supply_chain_loading);
                }).catch((error) => {
                  console.log(error);
                });

              Swal.fire(
                'Changed!',
                'Loading Status has been changed Successfully.',
                'success'
              );
              // setTimeout(() => {
              //  // window.location.href = "/orders";
              // }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }


  const PaymentStatusCell = ({ row }) => (
    <div className="btn-group custom-table-btn-group">
      <button
        type="button"
        className="btn btn-block dropdown-toggle me-1"
        id={`status-production-${row.original.id}`}
        style={{
          backgroundColor: row.original.location_status?.bg_color || 'transparent',
          color: row.original.location_status?.color || 'black',
        }}
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {row.original.location_status?.title || ''}
      </button>
      <div className="dropdown-menu">
        {statusOptions &&
          statusOptions.map((shipp) => (
            <button
              key={shipp.id}
              className="dropdown-item btn btn-block"
              style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
              onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
            >
              {shipp.title}
            </button>
          ))}
      </div>
    </div>
  );

  PaymentStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        location_status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }),
    }).isRequired,
  };
  const LotNumberCell = ({ row }) => {
    console.log("Row Data:", row); // Debugging to check row structure

    return (
      <a href={`/supplychain-loadings-view/${row?.original?.id || ''}`} className="">
        {/* {row?.original?.id || 'N/A'} */}
        {row?.original?.id?.split('-')[0] || 'N/A'}
        {/* {row?.original?.id?.split('-')[1] == 'loading'?' Loading Number':" Invoice"} */}
      </a>
    );
  };

  // ✅ Define PropTypes inside the function
  LotNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    }).isRequired,
  };


  const TotalAmountCell = ({ row }) => (
    <div>{Number(row.original.total_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
  );

  TotalAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        total_amount: PropTypes.number,
      }),
    }),
  };

  const Totaltransport_cost = ({ row }) => (
    <div>{Number(row.original.transport_cost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
  );

  Totaltransport_cost.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        transport_cost: PropTypes.number,
      }),
    }),
  };

  
  
  const updateDate = async (id,type) =>{
  
  
  
    //  const showDateInputAlert = async () => {
        const { value: date } = await  Swal.fire({
          title: 'Update Arival Date',
          html: '<input type="date" id="datePicker" class="swal2-input">',
          showCancelButton: true,
          confirmButtonText: 'Update',
          cancelButtonText: 'Cancel',
          customClass: "swal-orders",
          preConfirm: () => {
            return document.getElementById('datePicker').value;
          }
        });
       
        if (date) {
          // Do something with the selected date
          console.log('Selected date:', date);
              axios.get(`/supply-chain-loading/update-arrival-date/${id}/${date}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
              .then((response) => {
                console.log(response);
                
                if (response.data.code === 200) {
                  $("#button-"+type+"-"+id).text(response.data.data.date);
                  Swal.fire(
                    'Changed!',
                    'Date Updated Successfully.',
                    'success'
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              }); 
        }
  
  }
     const ProductionDateCell = ({ row, permission, updateDate }) => {
      const { original } = row;
    
      return (
        <div>
          {permission?.update === 1 ? (
            <button
              className="btn btn-primary btn-block"
              id={`button-all-${original.id}`}
              onClick={() => updateDate(original.id, 'all')}
            >
              {original.arrival_date ?? 'Update Date'}
            </button>
          ) : (
            <span>{original.arrival_date ?? 'N/A'}</span>
          )}
        </div>
      );
    };
    
    
    // ✅ Define PropTypes
    ProductionDateCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          arrival_date: PropTypes.string,
        }).isRequired,
      }).isRequired,
      permission: PropTypes.shape({
        update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      updateDate: PropTypes.func.isRequired,
    };
    
  const columns = [
    {
      header: 'Loading Number',
      accessorKey: 'id',
      Cell: LotNumberCell, // Use the separate component
    },

    {
      accessorKey: 'date_of_loading',
      header: 'Date',
    },
    {
      header: 'Invoice Number',
      accessorKey: 'invoice_number',
    },
    {
      header: 'Customer',
      accessorKey: 'company_name',
    },
    {
      header: 'Container Number',
      accessorKey: 'container_number',
    },
    {
      header: 'Transport Cost',
      accessorKey: 'transport_cost', // Changed from accessorFn
      Cell: Totaltransport_cost,
    },

    {
      header: 'Loading Status',
      accessorFn: (row) => row.location_status?.title || '',
      Cell: PaymentStatusCell,
    },

    {
      accessorKey: 'product_name',
      header: 'Product',
    },
    {
      accessorKey: 'po_number',
      header: 'PO Order',
    },
    {
      accessorKey: 'contract_number',
      header: 'Contract Number',
    },


    {
      header: 'ETA Date',
      accessorKey: 'eta_date',
    },
    {
      header: 'Location',
      accessorKey: 'location',
    },

    {
      accessorKey: 'total_net_weight',
      header: 'Quanity',
    },
    {
      header: 'Invoice Amount',
      accessorKey: 'total_amount', // Changed from accessorFn
      Cell: TotalAmountCell,
    },
    {
      accessorKey: 'total_boxes',
      header: 'Packaging',
    },
     {
        header: 'Arrival Date',
        accessorFn: (row) => row.arrival_date || '',
        Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      },
    {
      accessorKey: 'sous_dum',
      header: 'Sous Dum',
    },


    {
      header: 'Transit Supplier',
      accessorFn: (row) => (row.transitsupplier ? row.transitsupplier.name : ''),
    },


    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
    },
    {
      header: 'Created At',
      accessorFn: (row) => {
        let created_time = '';

        if (row.created_by !== 0) {
          created_time = row.created_at
            ? row.created_at.replace('T', ' ').substring(0, 19)
            : '';
        }

        return created_time;
      }
    },

    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
    },
    {
      header: 'Updated At',
      accessorFn: (row) => {
        let updated_time = '';

        if (row.updated_by !== 0) {
          updated_time = row.updated_at
            ? row.updated_at.replace('T', ' ').substring(0, 19)
            : '';
        }

        return updated_time;
      }
    },
  ];



  const [formData, setFormData] = useState({
    year: ''
  });
  const handleSelectChangeCustomer = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      year: selectedOption?.value || ''
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);
    axios.post("/supply-chain-loading/listing", formData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      setData(response.data.data.supply_chain_loading);
    }).catch((error) => {
      console.log(error);
    });
  }



  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }
  const downloadExcel = (e) => {
    console.log(e);
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/supply-chain-loading/listing-excel?${queryString}`, '_blank');
  }


  const syncScrollbar = (topScrollRef, containerSelector, data) => {
    console.log(data);
    const tableContainer = document.querySelector(containerSelector + ' .MuiTableContainer-root');
    const topScroll = topScrollRef.current;
    const topScrollContent = topScroll?.querySelector('.top-scroll-content');

    if (tableContainer && topScroll && topScrollContent) {
      topScrollContent.style.width = `${tableContainer.scrollWidth}px`;

      const handleTopScroll = () => { tableContainer.scrollLeft = topScroll.scrollLeft; };
      const handleTableScroll = () => { topScroll.scrollLeft = tableContainer.scrollLeft; };

      topScroll.addEventListener('scroll', handleTopScroll);
      tableContainer.addEventListener('scroll', handleTableScroll);

      return () => {
        topScroll.removeEventListener('scroll', handleTopScroll);
        tableContainer.removeEventListener('scroll', handleTableScroll);
      };
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      syncScrollbar(topScrollSemiRef, '.production-semi-listing', data);
    }, 100);
    return () => clearTimeout(timer);
  }, [data]);


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Supply Chain Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Supply Chain Loading
                    </li>
                  </ul>
                </div>

              </div>
            </div>
            <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                  <div className="row">



                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Year:</label>

                        <Select
                          options={years}
                          name="year"
                          value={years.find(option => option.value === formData.year) || ''}
                          onChange={handleSelectChangeCustomer}  // Simplified
                          isClearable  // Optional: allows clearing the selection
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="submit" className="btn btn-primary">
                          Filter
                        </button>
                        &nbsp;&nbsp;
                        <a href="/supplychain-loadings" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="col-auto mt-4" style={{ float: 'right' }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => downloadExcel()}
                        >
                          <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                        </button>
                        &nbsp;&nbsp;
                        {permission && permission.add == 1 && (
                          <Link to="/supplychain-loadings-add" className="btn btn-primary me-1" >
                            <i className="fas fa-plus"></i>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    {permission && permission.list === 1 && (
                      <div className="table-responsive">

                        <div
                          ref={topScrollSemiRef}
                          className="top-scrollbar"
                          style={{ overflowX: 'auto', overflowY: 'hidden', marginBottom: '10px', height: '90px' }}
                        >
                          <div className="top-scroll-content" style={{ height: '1px' }}></div>
                        </div>

                        <div className="table-responsive production-semi-listing" ref={tableContainerSemiRef}>
                          <MaterialReactTable columns={columns} data={data}
                            enableColumnOrdering
                            enablePinning
                            enableRowActions
                            //renderColumnActionsMenuItems 
                            renderRowActionMenuItems={({ row }) => [
                              permission?.update === 1 && (
                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                  Edit
                                </MenuItem>
                              ),
                              permission?.delete === 1 && (
                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                  Delete
                                </MenuItem>
                              ),
                            ]}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupplyChainLoading;
